export const CAMPAIGN_TYPE_MENTOR = 'Mentors';
export const CAMPAIGN_TYPE_PROTEGE = 'Protege';
export const CAMPAIGN_TYPE_STUDENTS = 'Students';
export const CAMPAIGN_TYPE_VOLUNTEERS = 'Volunteers';
